import * as _ from 'lodash-es';
import { Deserializable } from '@hm_app/@core/models/abstract_model';

export class MacrozonaCup extends Deserializable {
    idMacrozona: string; // "458";
    codiceMacrozona: string; // "2021011";
    descrizioneMacrozona: string; // "AREA DI MASSA CARRARA";
}

export class ZonaCup extends Deserializable {
    idZona: string; // "490",
    codiceZona: string; // "1101A",
    descrizioneZona: string; // "DELLA LUNIGIANA",
    macrozona: MacrozonaCup;

    deserialize(input: any) {
        super.deserialize(input);
        if (this.macrozona) {
            this.macrozona = new MacrozonaCup().deserialize(this.macrozona);
        }
        return this;
    }
}

export class EnteCup extends Deserializable {
    idEnte: string; // "02",
    idEnteRegionale: string; // "090202",
    descrizioneEnte: string; // "Azienda TOSCANA Nord Ovest",
    descrizioneRegionale: string; // "Az. USL Toscana nord-ovest",
}

export class SedeCup extends Deserializable {
    idSede: string; // "S_919",
    descSede: string; // "[101]-OSPEDALE FIVIZZANO",
    nomeSede: string; // "101801",
    indirizzoSede: string; // "SALITA SAN FRANCESCO",
    capSede: string; // "54034",
    istatComuneSede: string; // "045007",
    nomeComuneSede: string; // "FIVIZZANO",
    provinciaSede: string; // "MS",
    ente: EnteCup;
    zona: ZonaCup;

    deserialize(input: any) {
        super.deserialize(input);
        if (this.ente) {
            this.ente = new EnteCup().deserialize(this.ente);
        }
        if (this.zona) {
            this.zona = new ZonaCup().deserialize(this.zona);
        }
        return this;
    }

    get nomeVisualizzato(): string {
        if (!this.descSede) {
            return null;
        }

        const elems = this.descSede.split('-');
        if (elems.length > 1) {
            return elems[1];
        }
        return this.descSede;
    }
}

export class ErogatoreCup extends Deserializable {
    idErogatore: string; // "E_1056",
    descErogatore: string; // "HFI - DIABETOLOGIA",
    nomeErogatore: string; // "E_HFIDB"
}

export class UnitaCup extends Deserializable {
    idUnita: string; // "U_1457",
    descUnita: string; // "HFI-AMB.DIABETOLOGIA FIVIZZANO",
    nomeUnita: string; // "HFIDBEQUIPE",
    presidioUnita: string; // "2302",
    codicePresidioUnita: string; // "11161A",
    indirizzoUnita: string; // "SALITA S.FRANCESCO",
    telefonoUnita: string; // "0585/940215",

    get telefonoEsterno(): string {
        if (!this.telefonoUnita || !this.telefonoUnita.startsWith('05')) {
            return null;
        }
        return this.telefonoUnita;
    }

    erogatore: ErogatoreCup;
    sede: SedeCup;
    ente: EnteCup;
    zona: ZonaCup;

    deserialize(input: any) {
        super.deserialize(input);
        if (this.zona) {
            this.zona = new ZonaCup().deserialize(this.zona);
        }
        if (this.sede) {
            this.sede = new SedeCup().deserialize(this.sede);
        }
        if (this.ente) {
            this.ente = new EnteCup().deserialize(this.ente);
        }
        if (this.erogatore) {
            this.erogatore = new ErogatoreCup().deserialize(this.erogatore);
        }
        return this;
    }

}

export class PrestazioneCup extends Deserializable {
    idPrestazione: string; // "201700008937",
    statoPrestazione: string; // "B",
    idPrestazioneAnagrafica: string; // "8339",
    codicePrestazione: string; // "1066",
    costoPrestazione: string; // "22.00",
    codiceBranca: string; // "T",
    descrizionePrestazione: string; // "VISITA DIABETOLOGICA",
    dataOraAttivita: Date; // "20170401",
    dataAttivita: string; // "11:26",
    oraAttivita: string; // "11:26",
    unitaAttivita: UnitaCup;

    get isPrestazioneGravidanza(): boolean {
        return [
            '1598', // - ECOGRAFIA TRANSLUCENZA NUCALE
            '1591', // - ECOGRAFIA OSTETRICA (1 TRIMESTRE)
            '6961', // - ES. CITOLOGICO CERVICO-VAGINALE CONVENZIONALE (PAP TEST)
            '6904', // - PAPILLOMA VIRUS [HPV] GENOTIPIZZAZIONE
            '2D54', // - ECOGRAFIA OSTETRICA MORFOLOGICA (2 TRIMESTRE)
            '1596', // - ECOGRAFIA OSTETRICA (3 TRIMESTRE)
            '1457', // - CARDIOTOCOGRAFIA
            '1108', // - VISITA OSTETRICA
            '1140', // - VISITA DI CONTROLLO OSTETRICA
        ].includes('' + this.codicePrestazione);
    }

    deserialize(input: any) {
        super.deserialize(input);
        if (this.unitaAttivita) {
            this.unitaAttivita = new UnitaCup().deserialize(this.unitaAttivita);
        }
        return this;
    }

}

export class AppuntamentoCup extends Deserializable {
    idAppuntamento: string; // "7438",
    statoAppuntamento: string; // "PRENOTATO",
    dataOraAppuntamento: Date; // "20170401",
    dataAppuntamento: string; // "20170401",
    oraAppuntamento: string; // "11:26",
    unita: UnitaCup;
    listaPrestazioni: PrestazioneCup[];
    prescrizione: PrescrizioneCup;

    get isAppuntamentoLibretto(): boolean {
        for (const prestazione of this.listaPrestazioni) {
            if (prestazione.isPrestazioneGravidanza) {
                return true;
            }
        }
        return false;
    }

    deserialize(input: any) {
        super.deserialize(input);
        if (this.unita) {
            this.unita = new UnitaCup().deserialize(this.unita);
        }

        if (this.listaPrestazioni) {
            this.listaPrestazioni = this.listaPrestazioni.map(item => new PrestazioneCup().deserialize(item));
        }

        return this;
    }
}

export interface AppuntamentiFilters {
    data_inizio: string;
    data_fine: string;
    codice_libretto: string;
    codice_nre: string;
    distretto?: number;
}

export class ReportCup extends Deserializable {
    statoCorrettezzaAmministrativa: string; // "Controllo di correttezza amministrativa della richiesta non eseguito"
    statoPagamento: string; // "Z"
    tipoErogazione: string; // "1"
    tipoPrescrizione: string; // "ACCD_SSN"
    valoreStatoPagamento: string; // "DA_NON_PAGARE"
}

export class PrescrizioneCup extends Deserializable {
    idPrescrizione: string; // "201700005671",
    convenzione: string; // "103",
    tipoPrescrizione: string; // "SSN",
    tipoErogazione: string; // "1",
    numeroImpegnativa: string; // "090160163330165",
    dataOraImpegnativa: Date;
    dataImpegnativa: string; // "20170203",
    codiceEsenzione: string; // "013",
    cfPrescrittore: string; // "BRDPLG49B23M126B",
    classePriorita: string; // "P",
    costoPrescrizione: string; // "0.00",
    statoCorrettezzaAmministrativa: string; // "Controllo di correttezza amministrativa della richiesta superato, con attività da verificare",
    descrizioneDiagnosi: string; // "Quesito non specificato",
    listaAppuntamenti: AppuntamentoCup[];
    listaReportDisponibili: ReportCup[];

    invioSMSAbilitato: string;

    deserialize(input: any) {
        super.deserialize(input);

        if (this.listaAppuntamenti) {
            this.listaAppuntamenti = this.listaAppuntamenti.map(item => new AppuntamentoCup().deserialize(item));
            for (const a of this.listaAppuntamenti) {
                a.prescrizione = this;
            }
        }

        if (this.listaReportDisponibili) {
            this.listaReportDisponibili = this.listaReportDisponibili.map(item => new ReportCup().deserialize(item));
        }

        return this;
    }

}

